export default {"src":"/_next/static/media/LoanLogo.a41d28ce.svg","height":301,"width":255};